 import { Branding, BrandingDisabledIf, DisabledPrompt, useModel } from "bcms-react";
import { MainNavItem, MainNavMenuItem } from "../..";

/**
 * @name BID932MainNavItems
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 1224.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID1224MainNavView/>
 *      </div>
 *  );
 * }
 */
export default function BID932MainNavItems(props) {
    const { branding } = useModel();
    const { options } = branding;
                               
    const newAccountsLink =  <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountSummary", "/stopPayment", "/download"]}>
                                <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
                                <MainNavMenuItem label="eDocument Preference" route="/statementPreference" data-point="Nav_ePeference" />
                                <MainNavMenuItem label="Stop Payment" route="/stopPayment" data-point="Nav_Stop_Payments" />
                                <DisabledPrompt>
                                    <MainNavMenuItem label="Open an Account" data-point="Nav_Open_Account" />
                                </DisabledPrompt>
                                <MainNavMenuItem label="Credit Score" route="/creditScore" data-point="Nav_Credit_Score" />
                                <MainNavMenuItem className="download-transaction-history-link" label="Download" route="/download" data-point="Nav_Download" />
                                <MainNavMenuItem label="E-Statements & Notices" route="/statements" data-point="Nav_eStatements_Notices" />
                            </MainNavItem>;

    const zleMainNavItem = <MainNavItem label={<>Zelle<span className="r-mark">&reg;</span></>} route="/zelle" data-point="Nav_Zelle" />;

    const paymentLink = <MainNavItem label="Payments" route="/payments" data-point="Nav_Payments" />;

    const cardsLink = <BrandingDisabledIf id="chw23_courseid_abi22" exp={ value => value !== null && value !== undefined }>
                            <MainNavItem label="Cards" route="/chw23" data-point="Nav_Cards" />
                        </BrandingDisabledIf>;

    const alertsLink = <BrandingDisabledIf id="notifi_version_abi22"  exp={(val) => val !== "Disabled" }>               
                            <MainNavItem label="Alerts" route="/notifications" data-point="Nav_Alerts" />
                        </BrandingDisabledIf>;   

    const newTransfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={[ "/transfers", "/externalTransfers", "/transferActivity/scheduledTransfers", "/unlinkedTransferAccounts" ]} > 
                                <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer"/>
                                <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity"/>
                                <MainNavMenuItem label="External Transfers" route="/externalTransfers" data-point="Nav_External_Transfers"/>
                                <MainNavMenuItem label="Customer Transfer" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts"/>
                            </MainNavItem>;
                          
    
                            
    const pfmLink = options.pfm21_courseID_abi22 === null
    ? <DisabledPrompt><MainNavItem label="My Budget" data-point="Nav_My_Finances"/></DisabledPrompt> 
    : <MainNavItem label="My Budget" route="/myFinances" data-point="Nav_My_Finances"/>;

    // END: Branded links declared here and returned in the component.

    return (
        <Branding id="bid_abi22" value="932">
            <div className="flex-container flex-horizontal bid-932-menu">
                { newAccountsLink }
                { newTransfersLink }
                { paymentLink }
                { zleMainNavItem }
                { cardsLink }
                { pfmLink }   
                { alertsLink } 
            </div>
        </Branding>
    );
}
